<template>
  <div v-if="showLink">
    <span v-show="!showOnlyIcon" class="p-mr-2">{{ $t('Vehicle data') }}:</span>
    <a target="_blank"
       v-tooltip.top="showOnlyIcon ? $t('vehicleDataLinkTooltip') : null"
       :href="carDataUrl"
       draggable="false"
       :class="{'p-p-2':showOnlyIcon}">
      <i style="font-size: 0.85rem" class="pi pi-external-link"></i>
      <span v-show="!showOnlyIcon" class="p-ml-1">{{ plateNumber }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'CarDataLink',
  props: {
    plateNumber: {
      type: [String, null],
      default: null
    },
    showOnlyIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showLink() {
      return !!this.plateNumber && !this.$store.getters.isForkliftTenant && this.$store.getters.isLocationInEstonia
    },
    carDataUrl() {
      return `https://eteenindus.mnt.ee/public/soidukTaustakontroll.jsf?regMark=${encodeURIComponent(this.plateNumber || '')}`
    }
  }
}
</script>